import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <Link to="/" className="inline-block">
              <span className="text-3xl md:text-4xl font-bold font-heading text-background-50 whitespace-nowrap">
                Superbuy<br />Spreadsheet
              </span>
            </Link>
            <p className="mt-6 text-sm text-background-300 leading-relaxed max-w-md">
              The ultimate product research and shopping guide platform. Helping shoppers discover, compare, and organize products with confidence since 2024.
            </p>
            <div className="flex items-center gap-4 mt-8">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-600 text-background-300 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer">
                <i className="ri-global-line text-sm"></i>
              </a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-600 text-background-300 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer">
                <i className="ri-shopping-bag-3-line text-sm"></i>
              </a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-600 text-background-300 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer">
                <i className="ri-star-line text-sm"></i>
              </a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-600 text-background-300 hover:text-background-50 hover:border-background-400 transition-colors cursor-pointer">
                <i className="ri-heart-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-10 lg:gap-20 lg:w-3/5">
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-background-400 mb-5 whitespace-nowrap">Quick Links</h4>
              <div className="flex flex-col gap-3">
                <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">Home</Link>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">Superbuy Sheet</a>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">Buy It Now</a>
                <Link to="/article/what-is-superbuy-spreadsheet" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">Beginner Guide</Link>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-background-400 mb-5 whitespace-nowrap">Resources</h4>
              <div className="flex flex-col gap-3">
                <Link to="/article/what-is-superbuy-spreadsheet" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">Complete Guide</Link>
                <Link to="/article/superbuy-spreadsheet-safety-guide" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">Safety Center</Link>
                <Link to="/article/superbuy-spreadsheet-vs-alternatives" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">Comparisons</Link>
                <Link to="/article/how-to-use-superbuy-spreadsheet" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">Tutorials</Link>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-background-400 mb-5 whitespace-nowrap">Categories</h4>
              <div className="flex flex-col gap-3">
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">Shoes</a>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">Hoodies/Sweaters</a>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">T-Shirts</a>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">Jackets</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500 whitespace-nowrap">
            &copy; 2026 Superbuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">Main Site</a>
            <Link to="/" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">Privacy</Link>
            <Link to="/" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}